
import React, { useState } from 'react'
import { Form, Button, Container, Row, Col } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { toast, Toaster } from 'react-hot-toast'
import Cookies from 'js-cookie'
import '../Assets/Css/loginpage.css'
import { FaEye, FaEyeSlash } from 'react-icons/fa'

const AdminLogin = () => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const navigate = useNavigate()

  const handleAdminLogin = () => {
    if (!username || !password) {
      toast.error('Username and password are required')
      return
    }

    setLoading(true)

    // ✅ Correctly read from environment variables
    const adminUser = process.env.REACT_APP_ADMIN_USERNAME
    const adminPass = process.env.REACT_APP_ADMIN_PASSWORD

    // Optional: Console log for debugging
    // console.log("ENV username:", adminUser)
    // console.log("ENV password:", adminPass)

    if (username === adminUser && password === adminPass) {
      Cookies.set('adminToken', 'admin_logged_in', { expires: 3650, path: '' })
      toast.success('Login Success!')
      navigate('/dashboard')
    } else {
      toast.error('Invalid credentials')
    }

    setLoading(false)
  }

  return (
    <Container fluid className="d-flex justify-content-center align-items-center login-container">
      <Toaster position="top-center" reverseOrder={false} />
      <Row className="w-100 d-flex justify-content-center align-items-center">
        <Col xs={12} md={6} lg={4} className="d-flex justify-content-center align-items-center">
          <div className="login-form-container">
            <h3 className="login-header">Admin Login</h3>
            <Form>
              {/* Username Field */}
              <Form.Group className="mb-3" controlId="username">
                <Form.Label>Username</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter admin username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </Form.Group>

              {/* Password Field with toggle */}
              <Form.Group className="mb-3 position-relative" controlId="password">
                <Form.Label>Password</Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Enter admin password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    className="password-toggle-btn"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </Form.Group>

              {/* Login Button */}
              <Button
                type="button"
                className="w-100 login-button"
                onClick={handleAdminLogin}
                disabled={loading}
              >
                {loading ? 'Logging in...' : 'Login'}
              </Button>
            </Form>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default AdminLogin
